export default {
  title: 'Control de acceso',
  recoveryButton: 'Recuperar contraseña',
  newLink: 'Registrar nueva empresa',
  oldVersion: `Acceso a la versión clásica del módulo web de efactura`,
  help: 'Si necesitas ayuda accede al ',
  usermanual: `manual de usuario`,
  subtitle1: 'Si es proveedor, mediante nuestro servicio usted puede, entre otras operaciones:',
  text1: 'Emitir facturas y encaminarlas a sus clientes',
  text2: 'Conocer el estado de tramitación de sus facturas por parte de sus clientes',
  subtitle2: 'Y como cliente, mediante nuestro servicio usted puede, entre otras operaciones:',
  text3: 'Conocer las facturas que han emitido sus proveedores',
  text4: 'Aceptar o rechazar facturas recibidas',
  text5: 'Almacenar electrónicamente las facturas emitidas durante el periodo legalmente establecido.',
  text6: 'Recuperar un duplicado de cualquier factura almacenada con validez ante la Agencia Tributaria',
  button: 'Login',
  access: 'Acceder a la plataforma',
  howItWorks: 'Así funciona Sistema eFactura',
  news: 'Novedades y noticias',
  user: 'Usuario:',
  password: 'Contraseña:',
  nif: 'NIF/CIF/NIE/Otro:',
  removeOldVersion: 'La versión clásica dejará de estar operativa el día 15/11/2022',
  validate: {
    user: 'usuario',
    password: 'contraseña',
    nif: 'nif'
  },
  contract: {
    text: 'Si desea contratar nuestros servicios le informamos en',
    link: 'soporte.sistemaefactura@unifiedpost.com'
  },
  recovery: {
    title: 'Restaurar la contraseña de acceso',
    user: 'Usuario',
    nif: 'NIF/CIF/NIE/Otro',
    email: 'Email',
    button: 'Enviar contraseña',
    ok: 'Contraseña enviada al email del usuario'
  },
  temporalToken: {
    activeOk: 'Su cuenta se ha activado correctamente'
  },
  resetpasswd: {
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    restaurar: 'Restaurar',
    caracteresMinimos: 'Mínimo 6 caracteres',
    ok: 'Contraseña cambiada correctamente'
  },
  registry: {
    title: 'Registrar nueva empresa',
    companyData: 'Datos de la empresa',
    nif: 'NIF',
    reason: 'Razón Social',
    address: 'Dirección',
    addressPlaceholder: 'C\\',
    zipCodePlaceholder: 'C.P.',
    townPlaceholder: 'Localidad',
    cityPlaceholder: 'Provincia',
    countryPlaceholder: 'País',
    email: 'Email',
    phone: 'Teléfono',
    accessData: 'Datos de acceso',
    user: 'Usuario',
    pass: 'Contraseña',
    rePass: 'Repite Contraseña',
    repeatEmail: 'Repite Email',
    buttonRegistry: 'Registrar',
    buttonCancelRegistry: 'Cancelar',
    acceptConditions: 'Acepto las condiciones de uso...',
    captcha: 'captcha',
    validate: 'Validar',
    companyAlrealdyExists: 'la empresa ya está registrada, si tiene problema para acceder, contacte con nuestro soporte en el ',
    informaError: 'No se pueden recuperar los datos del NIF/CIF indicado. Para finalizar el alta, ponte en contacto con nuestro equipo de soporte en: ',
    seeTerms: 'Ver condiciones',
    modal: {
      title: 'Registro completado',
      text: 'Disfruta de nuestro servicio gratuito, en breve se pondrán en contacto con usted desde nuestro departamento comercial.',
      button: 'Aceptar'
    },
    errors: {
      5000: 'Se ha producido un error no esperado.',
      5001: 'Para registrarse en el sistema, debe indicar una cuenta de email corporativa.',
      5002: 'Se ha producido un error al enviar el correo de activación de cuenta, por favor ponte en contacto con nuestro equipo de soporte ',
      5003: 'Se ha producido un error al crear el nuevo usuario.',
      5004: 'Se ha producido un error al buscar el usuario.',
      5005: 'Se ha producido un error al regisrar la empresa en el sistema principal.',
      5006: 'Se ha producido un error al actualizar el usuario.',
      5007: 'No se puede registrar el usuario indicado, intenta introducir otro.'
    }
  },
  sesion: {
    error: 'Sesión caducada',
    bankiaError: 'Error de conexión. Código: ',
    longError: 'Su sesión ha expirado, se va a redirigir a la página de acceso',
    user_pass_invalid: 'Usuario o contraseñas incorrectas',
    user_pass_invalid_jcyl: `Usuario o contraseñas incorrectas. Si no recuerda su contraseña, envíe un email a <a href="mailto:igacyl.factura@jcyl.es">igacyl.factura@jcyl.es</a>.`,
    error_cas: {
      401: 'Se ha producido un error de acceso al sistema. En caso de que error persista por favor póngase en contacto con el Servicio de atención a usuarios',
      4011: 'Acceso no autorizado. El usuario debe de registrarse en la plataforma de Facturación Electrónica del Gobierno de La Rioja. <a href="https://web.larioja.org/portal-facturacion-e" target="_blank" style="color:#695596 !important;">https://web.larioja.org/portal-facturacion-e</a>'
    },
    inactive_user: 'El usuario esta deshabilitado temporalmente, póngase en contacto con el equipo de soporte a través del mail ',
    inactive_user_jcyl: 'El usuario esta deshabilitado temporalmente, póngase en contacto mediante correo electrónico con ',
    blocked_user: 'Su usuario está bloqueado, para desbloquearlo pulse en el siguiente link: <a href="/recovery" style="color:#695596 !important;">recuperar contraseña</a>.',
    blocked_user_jcyl: 'Su usuario esta bloqueado, póngase en contacto mediante correo electrónico con ',
    service_not_avaible: 'Servicio no disponible',
    service_not_avaible_jcyl: 'Servicio no disponible',
    expire: {
      title: 'Tu sesión esta próxima a expirar',
      description: 'Tu sesión va a expirar en {0} minutos'
    }
  },
  eurobits: {
    title1: 'Envíe sus facturas en formato electrónico',
    title2: 'Reciba sus facturas en formato electrónico',
    title3: 'Avisos por cambios de estado en sus facturas',
    title4: 'Interconexión con otras plataformas',
    text1: 'Puede crear sus facturas online, importarlas o integrarlas directamente desde su ERP.',
    text2: 'Puede recibir facturas de sus proveedores en cualquier formato y las podrá gestionar online o desde su ERP.',
    text3: 'Sistema de avisos que le enviará un email cuando sus facturas cambien de estado.',
    text4: 'Nuestra plataforma está conectada con otras como (FACe, BiscayTIK, AOC, etc.).'
  }
}
